import React from 'react'
import PropTypes from 'prop-types'

import {
    Box,
    Flex,
    Grid,
    Skeleton
} from '@salesforce/retail-react-app/app/components/shared/ui'
import CategoryCard from './category-card'
import {contentfulMediaFormatter} from '../../utils/contentful'

const CategoryGrid = ({data}) => {
    const dataItems = data?.items ?? []

    if (!dataItems || dataItems?.length === 0)
        return (
            <Box paddingX={{base: '17px', md: '32px'}}>
                <Skeleton width="100%" height="600px"></Skeleton>
                <Grid
                    paddingTop={{base: '60px', md: '40px'}}
                    templateColumns={{
                        base: '1',
                        md: `repeat(3, 1fr)`
                    }}
                    columnGap={{
                        md: '28px',
                        xl: '18px'
                    }}
                    rowGap={{base: '30px', md: '20px'}}
                >
                    {[1, 2, 3, 4, 5, 6].map((index) => {
                        return (
                            <Skeleton
                                key={index}
                                height={{base: '400px', xl: '200px'}}
                            />
                        )
                    })}
                </Grid>
            </Box>
        )

    return (
        <Flex
            py="24px"
            gap="25px"
            px={{base: '24px', lg: '40px'}}
            flexFlow={{base: 'column', lg: 'row'}}
        >
            {dataItems?.map(({sys, fields}) => (
                <CategoryCard
                    key={sys?.id}
                    data={{
                        ...fields,
                        banner: contentfulMediaFormatter(fields?.banner),
                        theme: fields?.theme?.fields ?? null,
                        cta: fields?.cta?.fields ?? null
                    }}
                />
            ))}
        </Flex>
    )
}

CategoryGrid.propTypes = {
    data: PropTypes.shape({
        items: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                name: PropTypes.string,
                type: PropTypes.string,
                required: PropTypes.bool,
                placeholder: PropTypes.string,
                errorMessage: PropTypes.string
            })
        )
    })
}

export default CategoryGrid
